export const DW_WW_HORIZONTAL_LOGO_URL =
  'https://storage.googleapis.com/digital-wisdoms-assets/web/web-wisdom-assets/dw_ww_logo_hori_black.png'

export const DW_WW_LOGO_URL =
  'https://storage.googleapis.com/digital-wisdoms-assets/web/web-wisdom-assets/web-wisdom-icon.png'

export const DW_LOTUS_LOGO_URL =
  'https://bookinglove.xyz/assets/bookinglove-lotus-logo-B0LYR4Vw.png'
export const CUSTOMER_PORTAL_BASE =
  'https://billing.stripe.com/p/login/5kAfZI8N5dgz0QUfYY'

export const FIREBASE_CONFIG = getFirebaseClientConfig()

const PROD_ENV_NAME = 'prod'

export function getFirebaseClientConfig() {
  const config = base64DecodeJSON(
    import.meta.env.VITE_PUBLIC_FIREBASE_CLIENT_CONFIG,
  )
  if (!config || !config.projectId) {
    throw new Error('Firebase config not found or invalid')
  }

  return config
}

export function getDwEnv(): string {
  const projectId = FIREBASE_CONFIG.projectId
  if (projectId.includes('staging')) return 'staging'
  return PROD_ENV_NAME
}

export function getEnvPrefix(): string {
  const env = getDwEnv()
  return env === PROD_ENV_NAME || env === 'ai' ? '' : `${env}-`
}

export const bucketUrl =
  getDwEnv() === PROD_ENV_NAME
    ? 'gs://digital-wisdom-ai-fb-uploads'
    : 'gs://digital-wisdom-staging-fb-uploads'

export async function getWisdomId(conciergeId: string): Promise<string> {
  const baseUrl = getBaseUrl()
  const response = await fetch(`${baseUrl}/concierge/${conciergeId}`, {
    method: 'GET',
    redirect: 'follow',
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch config: ${response.statusText}`)
  }

  const data = await response.json()
  return data.concierge.wisdomId
}

export function base64DecodeJSON(toDecode: string | undefined) {
  if (!toDecode) return {}

  try {
    const decoded = new TextDecoder().decode(
      Uint8Array.from(atob(toDecode), (c) => c.charCodeAt(0)),
    )
    return JSON.parse(decoded)
  } catch {
    return {}
  }
}

export function getSubmitUrl(): string {
  const baseUrl = getBaseUrl()
  return `${baseUrl}/submit/concierge`
}

export function getBaseUrl(): string {
  const dwEnv = getDwEnv()
  if (dwEnv === 'local') {
    return `https://staging-api.digitalwisdom.ai`
  }
  return `https://${dwEnv}-api.digitalwisdom.ai`
}
